export default "__VITE_ASSET__bcc7eee2__"